import { useAccount } from '@nizza/core';
import { useMutation } from '@tanstack/react-query';
import { useSettings } from 'lib/context';
import { addToCartProvider } from 'lib/core';
import { getDeviceType } from 'lib/utils';

type SendAddToCartParams = {
  id: string;
  sectionIdClickedOn: string;
  productId: string;
  productName: string;
  productImageUrl: string;
};

export const useSendAddToCart = () => {
  const { infoSocket, idLivestreaming } = useSettings();
  const { accountName } = useAccount();

  const sendAddToCartMutation = useMutation({
    mutationKey: ['sendAddToCart', accountName, idLivestreaming],
    mutationFn: async ({
      id,
      productId,
      productImageUrl,
      productName,
      sectionIdClickedOn,
    }: SendAddToCartParams) => {
      if (!accountName) return;

      addToCartProvider.sendAddToCart({
        id,
        account: accountName,
        idEvent: idLivestreaming,
        sessionId: infoSocket?.sessionId ?? '',
        isMobile: getDeviceType() === 'mobile',
        productId,
        productName,
        sectionFromWhereItWasAdded: sectionIdClickedOn,
        productImageUrl,
        email: '',
        orderFormId:
          window?.vtexjs?.checkout?.orderForm?.orderFormId ??
          sessionStorage.getItem('currentOrderForm') ??
          '',
      });
    },
  });

  return {
    sendAddToCartMutation,
  };
};
